import React, { useState } from "react";
import { get } from "lodash";

import { getIcon } from "../../../../helpers/icons";
import { planList } from "../../../../helpers/list";
import Title from "../../../../components/Title";
import Spacer from "../../../../components/Spacer";
import AsyncGet from "../../../../components/AsyncGet";
import FormatPrice from "../../Register/Step/FormatPrice";

import style from "../style.module.css";

export default function Details(props) {
    const {
        userProfile = {},
        planDetailsFromApi = {}
    } = props;
    const [isOpen, setIsOpen] = useState(false);
    const planId = get(userProfile, "membership.plan.id", "");
    return (
        <div className={style.details}>
            <div className={`${style.accordion}`}>
                <div className={`${style.accordionHeader}`} onClick={() => setIsOpen(prev => !prev)}>
                    Membership details <span><i className={getIcon(isOpen ? "Chevrondown" : "Chevronright")}></i></span>
                </div>
                <div className={`${style.accordionBody} ${isOpen ? style.open : ""}`}>
                    <div className={style.priceDetails}>
                        <div className={`${style.listItem} ${style.dashed} ${style.promotionalCodeApplyedAmountDetails}`}>
                            <div className={style.mainArea}>
                                <div className={style.planName}>
                                    <Title
                                        className="fontTeko"
                                        tag="h6"
                                        transform="uppercase"
                                    >
                                        Price Details
                                    </Title>
                                </div>
                                <div className={style.promotionalDescription}>
                                    <Title tag="p">
                                        <span>{get(planDetailsFromApi, "full_title", "")}</span>
                                        <span>{planList()[get(userProfile, "membership.plan.plan_type", "") || '']}</span>
                                        <span><FormatPrice planType={get(userProfile, "membership.plan.plan_type", "")} price={get(userProfile, "membership.plan.price", "")} /></span>
                                    </Title>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Spacer />
                    <div className={style.featureDetails}>
                        <div className={style.planName}>
                            <Title
                                className="fontTeko"
                                tag="p"
                                transform="uppercase"
                            >
                                Features
                            </Title>
                        </div>
                        <div className={style.featureList}>
                            {planId &&
                                <AsyncGet
                                    url={`/membership/${planId}`}
                                    permissionText={false}
                                    loadOnMount={true}
                                    render={({ data }) => {
                                        const features = data?.feature?.list || [];
                                        return features.length > 0 ? (
                                            features.map((item, index) => (
                                                <div className={style.featureListItem} key={`featureListItem_${index}`}>
                                                    <label className={style.checkbox}>
                                                        <input type="checkbox" className={style.checkboxInput} />
                                                        <div className={style.checkboxSquare}></div>
                                                        <div className={style.checkboxText}>
                                                            <span>{item.feature_name}</span>
                                                        </div>
                                                    </label>
                                                </div>
                                            ))
                                        ) : null;
                                    }}
                                />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}